
import { useWaiterTickets } from "context/WaiterTicketContext";
import toast from "react-hot-toast";
import api from "services/api";

function getFirstByCreatedAt(data) {
  if (!Array.isArray(data) || data.length === 0) return null;
  const sorted = data.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
  return sorted[0];
}

export default function useWaiterHelp() {
  const { waiterTickets } = useWaiterTickets();

  const currentWaiterTicket = getFirstByCreatedAt(waiterTickets);

  async function handleCheckTicket() {
    try {
      await api.put(`/restaurants/help-requests/check/${currentWaiterTicket.id}`);
      toast.success('Atendido com sucesso.');
    } catch (error) {
      toast.error('Erro ao atualizar chamado.');
    }
  }

  return {
    handleCheckTicket,
    waiterTicket: currentWaiterTicket,
    waiterTickets
  }
}